module.exports = __webpack_public_path__ + "img/panasonicdevice.4a6f5629.png";